module.exports = __webpack_public_path__ + "img/1f9ac.2497377.svg";